import Cookie from "js-cookie"
import _ from "lodash-es"
import { ResponseCode } from "@/utils/axios";
import BusEvent from "@/busEvent";

const defaultView = {
    position: [ 0, 500, 1000 ],
    target: [ 0, 0, 0 ]
}
const floorMesh = new AMRT.Mesh( new AMRT.PlaneGeometry( 3000, 3000, 1, 1 ), new AMRT.MeshBasicMaterial({ visible: false }) )
floorMesh.rotateX( -Math.PI / 2 )

export default {

    data(){
        return{
            readyScene: false,
            sceneData: {}
        }
    },

    mounted(){

    },

    methods: {

        /**
         * 初始化3D场景
         */
        async init( isFree = false ){

            if( this.$route.query.id ){
                //编辑
                this.axios.post( isFree ? '/api-application/interiorScene/detail' : '/api-application/interiorScene/detail', { 
                    id: this.$route.query.id,
                    userId: Cookie.get('loginId')
                }).then( (res ) => {
                    if( res.resp_code == ResponseCode.SUCCESS ){
                        this.sceneData = res.datas
                        let modelDatas, cameraData
                        try {
                            modelDatas = JSON.parse( res.datas.modelDatas )
                            cameraData = JSON.parse( res.datas.cameraData )                     
                        } catch (error) {
                            this.$message.error('初始化数据失败')
                        } 
                        this.initCanvas( modelDatas, cameraData )
                    }else{
                        this.$message.warning( res.resp_msg )
                    }
                })
            }else{
            //新建
                this.initCanvas()
            }
        },


        /**
         * 初始化画布
         */
        initCanvas( modelDatas, cameraData ){
            this.viewer = window.viewer = new AMRT.SceneViewer( this.$refs.container, { nv: 1 } )
            this.viewer.sceneManager.showGridHelp( 3000, 30 )
            this.viewer.mapLoader.loadEnvMap('https://waibu-demo.obs.cn-east-2.myhuaweicloud.com:443/texture/hdr/env.hdr', envMap => {
                this.readyScene = true
                this.viewer.resourceManager.envMap = envMap
                if( modelDatas ) {
                    const loading = this.$loading()
                    this.viewer.resourceManager.import( modelDatas, () => {
                        this.$bus.$emit( BusEvent.SceneChange )
                        this.initHotSpot()
                        loading.close()
                    })
                }
            })
            this.viewer.controls.maxPolarAngle = 90
            if( cameraData ){
                this.viewer.controls.flyTo( cameraData )
                this.viewer.cameraData = cameraData
            }else{
                this.viewer.controls.setView( defaultView )
                this.viewer.cameraData = defaultView
            }
            this.viewer.root.add( floorMesh )
            this.viewer.scene.floorMesh = floorMesh
        },

        /**
         * 初始化热点
         */
        initHotSpot(){
            let data = JSON.parse( this.sceneData.hotspotData )
            data.map( item => {
                let obj = this.$util.findModelByMid( item.mid )
                item.objectId = obj.id
                this.$refs.billboard.addHotSpot( item )
            })
        },


    }

}